// extracted by mini-css-extract-plugin
export var resourceDetail = "resourceDetail-2Ju";
export var image = "image-9AI";
export var date = "date-29B";
export var body = "body-15Z";
export var button = "button-CAI";
export var shareAndCta = "shareAndCta-dxS";
export var socials = "socials-3_B";
export var iframe_wrapper = "iframe_wrapper-1I8";